/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Drawer, DatePicker, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import OfficerName from '../../../components/Custom/OfficerName'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { AuthStore, form, updateDTR, onClose, dtr } = this.props
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const startDate = moment(values.start_date).format('YYYY-MM-DD HH:mm:ss')
			const endDate = moment(values.end_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values,  {
				log_date_in: startDate,
				log_date_out: endDate
			})
			if (dtr) {
				params = Object.assign({}, params, { dtr_uid: dtr.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_dtr', content: 'Saving Dtr, please wait..' })
			this.setState({ isSaving: true }, () => {
				updateDTR(params).then((response) => {
					this.setState({ isSaving: false })
					message.success({ key: 'set_dtr', content: 'Dtr successfully saved.' })

					//create audit trail
					const auditParams = {
						module_name: 'DTR',
						action: 'Update',
						message: `Update DTR details of staff with uid ${dtr.officer_uid}`
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error saving dtr')
					message.error({ key: 'set_dtr', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, dtr } = this.props
		const { getFieldDecorator } = form
        
		return (
			<Drawer
				title={<OfficerName officer_uid={dtr.officer_uid} />}
				placement="right"
				// closable={false}
				onClose={onClose}
				visible={visible}
				width={'35%'}
			>
				<Form onSubmit={this.handleSubmit}>
					<Row>
						<Form.Item label='Date Start'>
							{ getFieldDecorator('start_date', {
								initialValue: moment(dtr.log_date_in).isValid() ? moment(dtr.log_date_in) : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<DatePicker 
									showTime={{ format: 'h:mm A' }}
									format='lll'
									style={{ width: '100%' }}
								/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Date End'>
							{ getFieldDecorator('end_date', {
								initialValue: moment(dtr.log_date_out).isValid() ? moment(dtr.log_date_out) : null,
								rules: [{
									required: false,
									message: 'This field is required.'
								}]
							})
							(
								<DatePicker 
									showTime={{ format: 'h:mm A' }}
									format='lll'
									style={{ width: '100%' }}
								/>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Status'>
							{ getFieldDecorator('status', {
								initialValue: dtr ? dtr.status : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}]
							})
							(
								<Select placeholder='Select Status'>
									<Select.Option value='Started'>Started</Select.Option>
									<Select.Option value='Completed'>Completed</Select.Option>
									<Select.Option value='Lapsed'>Lapsed</Select.Option>
								</Select>
							)}
						</Form.Item>
					</Row>
					<Row>
						<Form.Item label='Remarks'>
							{ getFieldDecorator('remarks', {
								initialValue: dtr ? dtr.remarks : null,
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Input placeholder='Enter remarks' />
							)}
						</Form.Item>
					</Row>
				</Form>
				<div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div>
			</Drawer>
		)
	}
}

const UPDATE_DTR = gql`
    mutation updateDTR($input: JSON) {
		updateDTR(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-dtr' }),
	inject('AuthStore'),
	graphql(UPDATE_DTR, {
		props({ mutate }) {
			return {
				updateDTR(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['dtrLogs']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
